const TEXT = 'text';
const NUMBER = 'number';
const SELECT = 'select';
const DATE_TIME = 'date_time';
const BOOL = 'bool';
const INFO = 'info';
const MISC = 'misc';

// these are the field we can add ?
export const CUSTOM_FIELDS_V1_LIST = [
    1,13,2,3,4,5,6,7,14,8,9,10,11,12,17,15,16,19 //,18

    ,20 // reaction
    ,21 // voting
    ,22 // attachment
    ,23
    ,24 // Time of day
    ,25 // Date & time
    ,26 // address
    ,27 // internal DB
    ,28 // Department
    ,29 // Skills

]

export enum FieldTypeV1 {
    STRING       = 1,
    BOOLEAN      = 2,
    NUMBER       = 3,
    CURRENCY     = 4,
    PERCENTAGE   = 5,
    DATE         = 6,
    LIST         = 7,
    LIST_MULTI   = 14,
    RATING       = 8,
    EMAIL        = 9,
    PHONE        = 10,
    URL          = 11,
    USER         = 12,
    USERS        = 17,
    TEXT         = 13,
    RAG          = 15,
    FORMULA      = 16,
    DATE_RANGE   = 18,
    COLOR        = 19,

    // Fields V3
    REACTION        = 20,
    VOTING          = 21,
    ATTACHMENT      = 22,
    TOGGLE          = 23,
    TIME_OF_DAY     = 24, // Time of day
    DATE_AND_TIME   = 25,
    ADDRESS         = 26,
    INTERNAL_DB     = 27 // internal DB
}


const CUSTOM_FIELDS_V1 = {

    // deperecated use CustomFieldsV1Type
    type: {
        STRING       : 1,
        BOOLEAN      : 2,
        NUMBER       : 3,
        CURRENCY     : 4,
        PERCENTAGE   : 5,
        DATE         : 6,
        LIST         : 7,
        LIST_MULTI   : 14,
        RATING       : 8,
        EMAIL        : 9,
        PHONE        : 10,
        URL          : 11,
        USER         : 12,
        USERS        : 17,
        TEXT         : 13,
        RAG          : 15,
        FORMULA      : 16,
        DATE_RANGE   : 18,
        COLOR        : 19,

        // Fields V3
        REACTION        : 20,
        VOTING          : 21,
        ATTACHMENT      : 22,
        TOGGLE          : 23,
        TIME_OF_DAY     : 24, // Time of day
        DATE_AND_TIME   : 25,
        ADDRESS         : 26,
        INTERNAL_DB     : 27, // internal DB
        DEPARTMENT      : 28,
        SKILLS          : 29
    },

    // deprecated - see const above
    list: [
        1,13,2,3,4,5,6,7,14,8,9,10,11,12,17,15,16,19 //,18

        ,20 // reaction
        ,21 // voting
        ,22 // attachment
        ,23
        ,24 // time of day
        ,25 // Date & time
        ,26 // address
        ,27 // internal DB
    ],

    groups: {
        TEXT,
        NUMBER,
        SELECT,
        DATE_TIME,
        BOOL,
        INFO,
        MISC
    },

    groupLabel: {
        'text'      : 'Text',
        'number'    : 'Numbers',
        'select'    : 'Select',
        'date_time' : 'Date & Time',
        'bool'      : 'True/False',
        'info'      : 'Info',
        'misc'      : 'Misc'
    },


    1: {    id: 1,  label: 'Text',          icon: 'i5-text',                    className: 'text',          group: TEXT,        description: 'Generic text input field'},               // STRING
    2: {    id: 2,  label: 'Checkbox',      icon: 'i5-checkbox',                className: 'checkbox',      group: BOOL,        description: 'Form checkbox field'},                    // BOOLEAN
    3: {    id: 3,  label: 'Number',        icon: 'i5-numbers',                 className: 'number',        group: NUMBER,      description: 'Generic number field'},                   // NUMBER
    4: {    id: 4,  label: 'Currency',      icon: 'i5-money',                   className: 'currency',      group: NUMBER,      description: 'Currency input field'},                   // CURRENCY
    5: {    id: 5,  label: 'Percentage',    icon: 'i5-percent',   className: 'percentage',    group: NUMBER,      description: 'Percentage input field'},                 // PERCENTAGE
    6: {    id: 6,  label: 'Date',          icon: 'i5-calendar',                className: 'date',          group: DATE_TIME,   description: 'Generic date picker field'},              // DATE
    7: {    id: 7,  label: 'Dropdown',      icon: 'i5-dropdown',                className: 'dropdown',      group: SELECT,      description: 'Option select (dropdown) field'},         // LIST
    8: {    id: 8,  label: 'Rating',        icon: 'i5-star-empty',              className: 'rating',        group: MISC,        description: 'Rating select field'},                    // RATING
    9: {    id: 9,  label: 'Email',         icon: 'i5-big-mail',                className: 'email',         group: INFO,        description: 'Email input field'},                      // EMAIL
    10: {   id: 10, label: 'Phone',         icon: 'i5-phone',                   className: 'phone',         group: INFO,        description: 'Phone input field'},                      // PHONE
    11: {   id: 11, label: 'Link',          icon: 'i5-globe',                   className: 'link',          group: INFO,        description: 'Web link field'},                         // URL
    12: {   id: 12, label: 'User',          icon: 'i5-user',                    className: 'user',          group: MISC,        description: 'Company user select field'},              // USER
    13: {   id: 13, label: 'Textarea',      icon: 'i5-text-area',               className: 'textarea',      group: TEXT,        description: 'Multi-line text input (textarea) field'}, // TEXTAREA
    14: {   id: 14, label: 'Multiselect',   icon: 'i5-dropdown',                className: 'multiselect',   group: SELECT,      description: 'Multiple section field'},                 // LIST MULTI
    15: {   id: 15, label: 'RAG',           icon: 'i5-rag',                     className: 'rag',           group: MISC,        description: 'Red/Amber/Green select field'},           // RAG
    16: {   id: 16, label: 'Formula',       icon: 'i5-formula',            className: 'formula',       group: MISC,        description: 'Custom formula field'},                   // FORMULA
    17: {   id: 17, label: 'Users',         icon: 'i5-users',                   className: 'users',         group: MISC,        description: 'Company users multiple selection field'}, // USERS
    18: {   id: 18, label: 'Daterange',     icon: 'i5-calendar',                className: 'daterange',     group: DATE_TIME,   description: 'Date range (start-end) picker'},          // DATERANGE
    19: {   id: 19, label: 'Color',         icon: 'i5-color',                   className: 'color',         group: SELECT,      description: 'Color picker'},                           // COLOR

    // Field 3
    20: {
        id              : 20,
        label           : 'Reaction',
        icon            : 'i5-smile',
        className       : 'color',
        group           : MISC,
        description     : 'Add and display reactions'
    },

    21: {
        id              : 21,
        label           : 'Voting',
        icon            : 'i5-thumb-up',
        className       : 'color',
        group           : MISC,
        description     : 'Enable internal voting'
    },

    22: {
        id              : 22,
        label           : 'Attachment',
        icon            : 'i5-attachment',
        className       : 'color',
        group           : MISC,
        description     : 'Attach files to items'
    },

    23: {
        id              : 23,
        label           : 'Toggle',
        icon            : 'i5-toggle',
        className       : 'color',
        group           : BOOL,
        description     : 'Toggle'
    },

    24: {
        id              : 24,
        label           : 'Time of Day',
        icon            : 'i5-my-time',
        className       : 'color',
        group           : DATE_TIME,
        description     : 'Generic time picker field'
    },

    25: {
        id              : 25,
        label           : 'Datetime',
        icon            : 'i5-deadline', // Maybe different icon?!
        className       : 'color',
        group           : DATE_TIME,
        description     : 'Generic datetime picker field'
    },


    26: {
        id              : 26,
        label           : 'Address',
        icon            : 'i5-location',
        className       : 'color',
        group           : INFO,
        description     : 'Address input field'
    },

    27: {
        id              : 27,
        label           : 'Internal Database',
        icon            : 'ii5-database',
        className       : 'internal-db',
        group           : SELECT,
        description     : "Select a record from the internal custom database."
    },

    28: {
        id              : 28,
        label           : 'Department',
        icon            : 'i5-departments',
        className       : 'department',
        group           : MISC,
        description     : 'Field to select company department.'
    },

    29: {
        id              : 29,
        label           : 'Skills',
        icon            : 'i5-skills-big',
        className       : 'skills',
        group           : MISC,
        description     : 'Field to select company user skills'
    },

    label: {
        1: 'Text',
        STRING: 'Text',

        2: 'Checkbox',
        BOOLEAN: 'Checkbox',

        3: 'Number',
        NUMBER: 'Number',

        4: 'Currency',
        CURRENCY: 'Currency',

        5: 'Percentage',
        PERCENTAGE: 'Percentage',

        6: 'Date',
        DATE: 'Date',

        7: 'Dropdown',
        LIST: 'Dropdown',

        14: 'Multiselect',
        LIST_MULTI: 'Multiselect',

        15: 'RAG',
        RAG: 'RAG',

        16: 'Formula',
        FORMULA: 'Formula',

        17: 'Users',
        USERS: 'Users',

        18: 'Daterange',
        DATERANGE: 'Daterange',

        19: 'Color',
        COLOR: 'Color',

        20: 'Reaction',
        REACTION: 'Reaction',

        21: 'Voting',
        VOTING: 'Voting',

        22: 'Attachment',
        ATTACHMENT: 'Attachment',

        23: 'Toggle',
        TOGGLE: 'Toggle',

        24: 'Time of Day',
        TIME_OF_DAY: 'Time of Day',

        25: 'Datetime',
        DATE_AND_TIME: 'Datetime',

        26: 'Address',
        ADDRESS: 'Address',

        27: 'Internal Database',
        INTERNAL_DB: 'Internal Database',

        28: 'Department',
        DEPARTMENT: 'Department',

        29: 'Skills',
        SKILLS: 'Skills',
    },

    // is it in use ????
    icon: {
        1: 'i5-text',
        STRING: 'i5-text',

        2: 'i5-checkbox',
        BOOLEAN: 'i5-checkbox',

        3: 'i5-numbers',
        NUMBER: 'i5-numbers',

        4: 'i5-money',
        CURRENCY: 'i5-money',

        5: 'i5-percent',
        PERCENTAGE: 'i5-percent',

        6: ' i5-calendar',
        DATE: ' i5-calendar',

        7: 'i5-dropdown',
        LIST: 'i5-dropdown',

        14: 'i5-dropdown',
        LIST_MULTI: 'i5-dropdown',

        15: 'i5-dropdown',
        RAG: 'i5-dropdown',

        16: 'i5-formula',
        FORMULA: 'i5-formula',

        17: 'i5-user',
        USERS: 'i5-user',

        19: 'i5-color',
        COLOR: 'i5-color',

        20: 'i5-smile',
        REACTION: 'i5-smile',

        21: 'thumb-up',
        VOTING: 'thumb-up',

        22: 'i5-attachment',
        ATTACHMENT: 'i5-attachment',

        23: 'i5-toggle',
        TOGGLE: 'i5-toggle',

        24: 'i5-my-time',
        TIME_OF_DAY: 'i5-my-time',

        25: 'i5-deadline',
        DATE_AND_TIME: 'i5-deadline',

        26: 'i5-location',
        ADDRESS: 'i5-location',

        27: 'i5-dropdown',
        INTERNAL_DB: 'i5-dropdown',

        28: 'i5-departments',
        DEPARTMENT: 'i5-departments',

        29: 'i5-skills-big',
        SKILLS: 'i5-skills-big',
    },

    // deprecated - used CustomFieldAccess
    access: {
        EVERYONE: 1,                // voobche vse... gd.const.companyRole.CLIENT,
        MANAGERS_ONLY: 4,           // oups... eto full access project gd.const.companyRole.MANAGER
    },

    accessLabel: {
        EVERYONE: 'Everyone',
        MANAGERS_ONLY: 'Organization managers',
    },

    // deprecated - use enum CustomFieldScope
    scope: {
        TASK    : 1,
        PROJECT : 2,
        USER    : 3,

        CUSTOM  : 100
    },

    getGroupColor: (group:any) => {
        switch (group) {
            case gd.const.customFields.groups.TEXT:      return 'blue';
            case gd.const.customFields.groups.NUMBER:    return 'green';
            case gd.const.customFields.groups.SELECT:    return 'yellow';
            case gd.const.customFields.groups.DATE_TIME: return 'violet';
            case gd.const.customFields.groups.BOOL:      return 'coral';
            case gd.const.customFields.groups.INFO:      return 'darkblue';
            case gd.const.customFields.groups.MISC:      return 'pink';
        }
    }
};

export default CUSTOM_FIELDS_V1;
